import { styled } from '@mui/material/styles'
import { AppBar, FormControl, Select, Box, Button, TextField, Typography, CardMedia, CardContent, Card } from '@mui/material'

export const HelpAppBar = styled(AppBar)(({ theme }) => ({
  height: '50px',
  borderBottom: 'none',
  boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.16)',
  background: theme.palette.common.white,
  '& .MuiToolbar-root': {
    minHeight: '50px',
    alignItems: 'center'
  },
  '& img': {
    height: 'inherit',
    width: 'auto',
    [theme.breakpoints.up('sm')]: {
      height: 24
    }
  }
}))

export const FormControlLanguage = styled(FormControl)(({ theme }) => ({
  color: theme.palette.grey[400],
  borderBottom: 'none',
  flexDirection: 'row',
  alignItems: 'center',
  margin: '0px',
  width: '50px',
  cursor: 'pointer',
  '&::before': {
    borderBottom: 'none'
  },
  '& :hover': {
    color: theme.palette.grey[200]
  }
}))

export const SelectLanguage = styled(Select)(({ theme }) => ({
  cursor: 'pointer',
  height: 'auto',
  margin: '0px',
  top: '-1px',
  paddingLeft: theme.spacing(3),
  color: theme.palette.grey[400],
  display: 'flex',
  alignItems: 'center',
  '& svg': {
    display: 'none'
  },
  '&::before': {
    borderBottom: 'none !important'
  }
}))

export const AppLogo = styled('img')(({ theme }) => ({
  height: 24,
  [theme.breakpoints.down('sm')]: {
    height: 20
  }
}))

export const HeroSection = styled(Box)(() => ({
  backgroundSize: 'cover',
  backgroundPosition: 'center'
}))

export const CardsContainer = styled(Box)(() => ({
  marginTop: '-153px'
}))

export const CardItem = styled(Card)(() => ({
  maxWidth: 294,
  textAlign: 'center',
  borderRadius: 16,
  boxShadow: '0px 8px 25px rgba(0, 0, 0, 0.1)'
}))

export const CardItemHover = styled(Box)({
  backgroundColor: 'transparent'
})

export const FocusCardContent = styled(Box)({
  padding: 32,
  '&:hover': {
    backgroundColor: 'transparent'
  }
})

export const CardIconWrapper = styled(CardMedia)({
  height: 87,
  backgroundSize: 'inherit'
})

export const CardTextContent = styled(CardContent)(({ theme }) => ({
  marginTop: 16,
  gap: 16,
  display: 'grid',
  padding: 0,
  '&:hover h5': {
    color: theme.palette.primary.main
  }
}))

export const OptionButton = styled(Button)(({ theme }) => ({
  height: 110,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    maxWidth: 155
  },
  '&:hover': {
    border: 'transparent',
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white
  }
}))

export const ContactButton = styled(Button)({
  marginTop: 32,
  marginBottom: 120,
  height: 41,
  width: 124
})

export const FormInput = styled(TextField)(() => ({
  '& .MuiInputBase-root': {
    border: 'none',
    borderBottom: '1px solid #73808C',
    boxShadow: '0px 8px 25px 0px rgba(0, 0, 0, 0.1)',
    padding: '9px 14px',
    background: '#FAFAFA',
    borderRadius: '8px',
    fontSize: '1rem',
    maxWidth: '100%',
    maxHeight: '42px',
    color: '#73808C'
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none'
  }
}))

export const FormTextArea = styled(TextField)(() => ({
  '& .MuiInputBase-root': {
    border: 'none',
    borderBottom: '1px solid #73808C',
    boxShadow: '0px 8px 25px 0px rgba(0, 0, 0, 0.1)',
    padding: '9px 14px',
    background: '#FAFAFA',
    borderRadius: '8px',
    fontSize: '1rem',
    maxWidth: '100%',
    color: '#73808C'
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none'
  }
}))

export const SectionTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[600],
  marginBottom: 12
}))

export const MenuContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.between('xs', 'md')]: {
    justifyContent: 'center'
  },
  [theme.breakpoints.up('sm')]: {
    gap: 88
  }
}))

export const DetailContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column-reverse'
  }
}))

export const TextContent = styled(Box)(({ theme }) => ({
  paddingRight: 32,
  [theme.breakpoints.up('sm')]: {
    paddingLeft: 53,
    width: 'calc(100% - 352px)'
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    paddingRight: 0,
    paddingLeft: 0
  }
}))

export const NavContent = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    maxWidth: '260px'
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    maxWidth: 'max-content'
  }
}))

export const SelectedOption = styled(Box)(({ theme }) => ({
  color: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: `${theme.palette.common.white} !important`
  }
}))

export const DisabledElement = styled(Box)({
  opacity: 'inherit !important'
})
